import client from "../../../api/client";
import mapResendOtpPayload from "../utils/mapResendOtpPayload";

export default async function resendLoginOtp(email) {
  const payload = mapResendOtpPayload(email);
  const response = await client.post("/auth/resend-otp", payload);
  return response.data;
}